/**
 * <ma-sticky-atc> — sticky add-to-cart bar (Figma 943:1421 / 1069:3735).
 * Shows when the main add-to-cart button leaves the viewport; the bar's own
 * qty mirrors the main qty input and the button submits the main product form.
 */
if (!customElements.get('ma-sticky-atc')) {
  class MaStickyAtc extends HTMLElement {
    connectedCallback() {
      const section = this.closest('product-info');
      this.watch = document.querySelector(this.dataset.watch);
      this.form = section && section.querySelector('form[id^="product-form-"]');
      this.mainQty = section && section.querySelector('.ma-pdp-hero__buy-row input[name="quantity"]');
      this.qty = this.querySelector('input[name="quantity"]');
      this.price = this.querySelector('[data-price]');
      this.btn = this.querySelector('[data-submit]');
      if (!this.watch || !this.form) return;

      // show only once the main button has scrolled up and out (not while it's still below the fold)
      // scroll check, not IntersectionObserver: a fast flick or jump from above to below the button never
      // "crosses" it, so the observer never fired and the bar stayed hidden
      let ticking = false;
      // re-query: variant changes can re-render the main button
      const check = () => { ticking = false; this.watch = document.querySelector(this.dataset.watch) || this.watch; this.toggle(this.watch.getBoundingClientRect().bottom < 0); };
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();

      // keep both qty inputs in sync (quantity-input already handles +/-)
      this.qty.addEventListener('change', () => { this.mainQty.value = this.qty.value; this.mainQty.dispatchEvent(new Event('change', { bubbles: true })); });
      this.mainQty.addEventListener('change', () => { this.qty.value = this.mainQty.value; });

      // ponytail: price follows Dawn's variant re-render of the main price block
      const mainPrice = section.querySelector('.ma-pdp-hero__price');
      if (mainPrice) new MutationObserver(() => {
        const el = mainPrice.querySelector('.ma-pdp-hero__price-now');
        if (el) this.price.textContent = el.textContent.trim();
      }).observe(mainPrice, { childList: true, subtree: true, characterData: true });

      this.btn.addEventListener('click', () => this.watch.click());
    }
    toggle(show) {
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', String(!show));
      this.querySelectorAll('button, input').forEach((el) => (el.tabIndex = show ? 0 : -1));
    }
  }
  customElements.define('ma-sticky-atc', MaStickyAtc);
}
